import React, { Component } from "react";
import utils from "./UtilityService";
import translationService from "./TranslationService";
import Widget from "./Widget";
import ControlMessagesNew from "@tinqin/tinqin-ui-components/src/control-messages/ControlMessages";
import ControlMessageGroupNew from "@tinqin/tinqin-ui-components/src/control-messages/ControlMessageGroup";
import Paragraph from "@tinqin/tinqin-ui-components/src/paragraph/Paragraph";
import webuiState from "./InternalStateService";
import containerUtils from "../utils/containerUtils";
import { WEBUILogs } from "@tinqin/tinqin-utils/src/logging";

export class WidgetDashboard extends Component {
    componentDidCatch(error, info) {
        let widgetState = {
            state: "error",
            message: translationService.translate("renderErrorMessage")
        };
        this.props.setWidgetErrorState(this.props.widgetId, widgetState);
    }

    buildWidgetRegions() {
        let widgetsByRegion = {};
        let widgets = this.props.data.widgets || {};

        this.props.config.widgets.forEach((widgetProps = {}, index) => {
            let DashboardWidget = Widget;
            let widgetsData = widgets.find(widgetData => {
                return widgetData.id === widgetProps.id;
            });
            let widgetProperties = Object.assign({}, widgetProps, widgetsData);
            //widgetProperties.loadingType = "none";
            if (
                widgetProperties.hasOwnProperty("type") &&
                widgetProperties.type === "widgetContainer"
            ) {
                DashboardWidget = webuiState.getComponent("widgetContainer");
            }
            widgetProperties.parentWidget = this.props.widgetId;
            let key = widgetProps.id || index;
            //default dashboard region
            let widgetRegion = widgetProps.region || "main";
            //initialize widget regions
            widgetsByRegion[widgetRegion] = widgetsByRegion[widgetRegion] || [];
            //widgets may have specific position
            if (typeof widgetProps.position === "undefined") {
                widgetsByRegion[widgetRegion].push(
                    <DashboardWidget key={key} {...widgetProperties} />
                );
            } else {
                widgetsByRegion[widgetRegion].splice(
                    Math.max(widgetProps.position - 1, 0),
                    0,
                    <DashboardWidget key={key} {...widgetProperties} />
                );
            }
        });

        return widgetsByRegion;
    }
    getTemplate() {
        let templateId;
        let template;
        let config = this.props.config || {};
        //template can be an object
        if (typeof config.template === "string") {
            templateId = config.template;
        } else {
            templateId = config.template && config.template.id;
        }
        let templates = webuiState.getDashboardTemplates();
        template = templates[templateId];

        if (!template) {
            WEBUILogs.error("Unknown dashboard template: " + templateId);
            WEBUILogs.warn("Default template will be render!");
            return templates["DefaultTemplate"];
        }

        return template;
    }

    render() {
        let config = this.props.config || {};
        let data = this.props.data || {};
        let uiState = this.props.uiState || {};

        let props = containerUtils.extractComponentProps(this.props, {
            additionalProps: [
                "extraClasses",
                "visible",
                "resolveWhenHidden",
                "cached",
                "loadingType"
            ],
            propsDefaults: { visible: true }
        });

        //there is a hidden container, that should not trigger loading of child widget
        //there is a hidden container with hidden loading of child widgets
        if (!props.visible && !props.resolveWhenHidden) {
            return null;
        }

        //in case critical messages has been triggered inside the widget
        let hasWidgetMessages = data.widgetState;
        if (hasWidgetMessages) {
            return (
                <ControlMessagesNew extraClasses="tq-gutter-all">
                    <ControlMessageGroupNew
                        groupType={data.widgetState.state}
                        name={translationService.translate(data.widgetState.state)}
                    >
                        <Paragraph text={data.widgetState.message} />
                    </ControlMessageGroupNew>
                </ControlMessagesNew>
            );
        }

        let missingData = !this.props.data || !this.props.config;
        //application global property - legacyWidgetLoadingAnimation
        //by default no widget loading animation container
        const widgetLoading = webuiState.getGlobalProperties("widgetLoadingAnimation");
        if (missingData && widgetLoading) {
            let WidgetLoadingAnimation = webuiState.getComponent("widgetLoading");

            let isCached = props.cached;

            let isLoading = uiState.loading;
            //Loading animation type, only "none" so far
            let loadingType = props.loadingType || false;
            let noLoading = loadingType === "none";

            //will not show loading in case disabled (noLoading)
            //shows loading in case uiSate flag is set and the widget is not cached
            //or the widget is cached but data is missing(initial render)
            let showLoading = !noLoading && isLoading && (!isCached || missingData);
            let loadingProp = {
                isLoading: showLoading
            };
            let loadingMinHeight = props.loadingMinHeight;
            if (loadingMinHeight) {
                loadingProp.minHeight = loadingMinHeight;
            }
            return <WidgetLoadingAnimation {...loadingProp} />;
        }

        let widgetClasses = "";
        widgetClasses += !props.visible ? "tq-hide " : "";
        widgetClasses += config.extraClasses ? config.extraClasses : "";

        if (data.widgets && config.template) {
            let DashboardTemplate = this.getTemplate();

            return (
                <DashboardTemplate
                    template={config.template}
                    regions={this.buildWidgetRegions()}
                    extraClasses={widgetClasses}
                />
            );
        }

        return <span data-no-content="true" />;
    }
}

export default utils.connectWidget({
    loadWidgetContainer: "widgetContainer.loadWidgetContainer",
    setWidgetErrorState: "widget.setWidgetErrorState"
})(WidgetDashboard);
